module.exports = __webpack_public_path__ + "static/img/2.9144989.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/2.jpg
// module id = +4vT
// module chunks = 0